import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Button from "@/components/site/Button";
import { formatDatumNL } from "@/lib/datum";

const EASE = [0.16, 1, 0.3, 1];

/**
 * Gedeelde artikelweergave: publieke artikelpagina én de voorbeeldweergave
 * in het beheer gebruiken exact dit blok.
 */
export default function BlogArticle({ post, preview = false }) {
    return (
        <article data-testid={preview ? "blog-preview-article" : "blog-article"}>
            <p className="text-[11.5px] tracking-[0.28em] uppercase text-[var(--hds-clay)]/90 mb-5">
                Blog{post.published_at ? ` · ${formatDatumNL(post.published_at)}` : ""}
            </p>
            <h1
                className="font-[Fraunces] text-[34px] md:text-[56px] leading-[1.04] tracking-[-0.02em] text-[var(--hds-ink)]"
                style={{ fontWeight: 300 }}
                data-testid="blog-article-title"
            >
                {post.title}
            </h1>
            {post.featured_image && (
                <img
                    src={post.featured_image}
                    alt={post.featured_alt || ""}
                    data-testid="blog-article-image"
                    className="mt-8 md:mt-10 w-full rounded-[14px] border border-[var(--hds-line)] object-cover object-[center_25%] max-h-[460px]"
                />
            )}
            <div
                className="hds-blog-body mt-8 md:mt-10 max-w-[68ch]"
                data-testid="blog-article-body"
                dangerouslySetInnerHTML={{ __html: post.body || "" }}
            />

            {/* CTA-blok */}
            <div
                className="relative overflow-hidden rounded-[18px] bg-[var(--hds-clay)] text-[var(--hds-card)] px-7 md:px-12 py-12 md:py-14 mt-14 md:mt-20"
                data-testid="blog-cta"
            >
                <div
                    aria-hidden
                    className="pointer-events-none absolute -right-16 -top-16 w-[260px] h-[260px] rounded-full"
                    style={{
                        background:
                            "radial-gradient(circle at 35% 30%, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 70%)",
                    }}
                />
                <h2
                    className="font-[Fraunces] text-[28px] md:text-[40px] leading-[1.06] tracking-[-0.02em]"
                    style={{ fontWeight: 300 }}
                >
                    Klaar om ermee aan de slag te gaan?
                </h2>
                <div className="mt-8 flex flex-col sm:flex-row gap-4">
                    <Button to="/boeken" variant="onClayPrimary" icon="arrow" data-testid="blog-cta-boek">
                        Boek een sessie
                    </Button>
                    <Button to="/gratis-qa" variant="onClaySecondary" data-testid="blog-cta-qa">
                        Gratis Q&A
                    </Button>
                </div>
            </div>

            {!preview && (
                <div className="mt-10">
                    <Link
                        to="/blog"
                        data-testid="blog-back"
                        className="text-[13.5px] text-[var(--hds-ink)]/60 hover:text-[var(--hds-clay)] underline underline-offset-2"
                    >
                        Terug naar alle artikelen
                    </Link>
                </div>
            )}
        </article>
    );
}
